import { render } from "./BreathRate.vue?vue&type=template&id=3f309cc2&scoped=true&ts=true"
import script from "./BreathRate.vue?vue&type=script&lang=ts"
export * from "./BreathRate.vue?vue&type=script&lang=ts"

import "./BreathRate.vue?vue&type=style&index=0&id=3f309cc2&scoped=true&lang=less"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f309cc2"]])

export default __exports__